module.exports = __webpack_public_path__ + "static/mock.524d9c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/mock.jpg
// module id = 1162
// module chunks = 35783957827783